import { render, staticRenderFns } from "./AddUserPopupCloud.vue?vue&type=template&id=51a0d689&"
import script from "./AddUserPopupCloud.vue?vue&type=script&lang=js&"
export * from "./AddUserPopupCloud.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VDataTable,VDialog,VPagination,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/-36BVGaF/0/applicationg/aims-dashboard/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51a0d689')) {
      api.createRecord('51a0d689', component.options)
    } else {
      api.reload('51a0d689', component.options)
    }
    module.hot.accept("./AddUserPopupCloud.vue?vue&type=template&id=51a0d689&", function () {
      api.rerender('51a0d689', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/User/modal/AddUserPopupCloud.vue"
export default component.exports